import { render, staticRenderFns } from "./SubjectLabels.vue?vue&type=template&id=d4df0e5c&scoped=true&"
import script from "@/views/SubjectLabels/SubjectLabels.ts?vue&type=script&lang=ts&"
export * from "@/views/SubjectLabels/SubjectLabels.ts?vue&type=script&lang=ts&"
import style0 from "@/views/SubjectLabels/SubjectLabels.scss?vue&type=style&index=0&id=d4df0e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4df0e5c",
  null
  
)

export default component.exports